import { render, staticRenderFns } from "./Detail-Location.vue?vue&type=template&id=1177b550"
import script from "./Detail-Location.vue?vue&type=script&lang=js"
export * from "./Detail-Location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports